export default __webpack_public_path__ + "static/media/profile_icon-15.14b2261a.png";